export enum SipTransportProtocol {
  UDP = 0,
  TCP = 1,
  TLS = 2,
  WSS = 3,
}
